<template>
  <div id="header">
    <ul>
      <li class="headleft">
        <img src="@/assets/logo.png" alt="">
        <span>量云</span>
      </li>
      <li class="headright">
        <div class="name">消耗管理平台</div>
        <div class="usermsg">
          <span class="time">{{now}}</span>
          <!-- 通知区域 -->
          <div v-if="noticeVisible" class="imgbox commomImg" @click="userNotice">
            <img :src="notificationImg" alt="">
          </div>
          <!-- 下拉显示 -->
          <div class="user dropdown">
            <img :src="userMsg.avatar" alt="" class="avatar">
            <span>{{userMsg.name}}</span>
            <img src="@/assets/akar-icons_chevron-down.png" alt="" class="go" @click="showUserDropDown= true">
            <div v-if="showUserDropDown" id="s-user-name-menu" class="s-top-userset-menu c-floating-box c-font-normal">
              <a class="user-menu-item" data-tid="1000" href="javascript:;" @click="showUserInfo">个人信息</a>
              <a class="quit" style="overflow:hidden" href="javascript:;"  @click="loginOut">退出登录</a>
            </div>
          </div>
        </div>
        <Profile :visible="userInfoDialogVisible" @close="userInfoDialogVisible=false"/>
      </li>
    </ul>
  </div>
</template>

<script>
import {formatCurrentDateByNianYueRi} from '@/util/fun'
import {notice} from '@/api/user'
import Profile from "@/components/user/profile.vue";
import {Message} from "element-ui";
export default {
  name:"zxHeader",
  components: {Profile},
  data(){
    return {
      userMsg:{
        avatar: this.$store.getters.avatar,
        name: this.$store.getters.nickName
      },
      now: formatCurrentDateByNianYueRi(),
      userInfoDialogVisible: false,
      alreadyNotice: false,
      notificationImg: require('@/assets/mi_notification.png'),
      // 是否显示用户下拉菜单
      showUserDropDown: false,
      noticeVisible: true
    }
  },
  mounted() {
    if (this.$store.getters.adminRole) {
      this.noticeVisible = false;
    } else {
      this.noticeVisible = true;
    }
  },
  methods: {
    showUserInfo() {
      this.userInfoDialogVisible = true;
      this.showUserDropDown = false;
    },
    userNotice() {
      if (this.alreadyNotice) {
        return;
      }
      let _this = this;
      notice().then(res => {
        if (res.ok) {
          _this.notificationImg = require('@/assets/notification.png');
          this.$notify({
            type: 'success',
            message: res.data,
            position: 'bottom-right',
          });
          _this.alreadyNotice = true;
        } else {
          Message({type: 'error', message: res.msg});
        }
      })
    },
    loginOut(){
      this.$store.dispatch("user/LogOut")
          .then(() => {
            this.$store.commit('user/SET_NAME', '')
            this.$store.commit('user/SET_NICK_NAME', '')
            this.$store.commit('user/SET_AVATAR', '')
            this.$store.commit('user/SET_USERID','')
            this.$store.commit('user/SET_ADMIN_ROLE', '')
        this.$router.push({ path: "/login" || "/" }).catch(() => { });
      }).catch(() => {
        this.loading = false;
        if (_this.captchaEnabled) {
          this.getCode();
        }
      });
    }
  }
}
</script>

<style lang="less">
    #header{
        width: 100%;
        background-color: #fff;
        border-radius: 24px;
        padding: 0px 50px 0px 24px;
        box-shadow: 0px 20px 60px  rgba(0, 0, 0, 0.05);
        margin-bottom: 70px;
        ul{
          display: flex;
          .headleft{
            display: flex;
            align-items: center;
            font-size: 28px;
            font-weight: 400;
            letter-spacing: 0.28px;
            color: rgba(0, 30, 192, 1);
            padding-right: 66px;
            border-right: 1px solid rgba(211, 211, 211, 1);
            margin-right: 22px;
            img{
              margin-right: 6px;
              width: 40px;
            }
          }
          .headright{
            flex: 1 0 10%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .name{
              font-size: 28px;
              font-weight: 400;
              color: rgba(0, 30, 192, 1);

            }
            .usermsg{
              display: flex;
              align-items: center;
              position: relative;
              .avatar{
                width:52px;
                margin-right: 12px;
                border-radius: 50%;
              }
              .time{
                font-size: 16px;
                font-weight: 400;
                color: rgba(163, 163, 163, 1);
                display: inline-block;
                margin-right: 12px;
              }
              .user{
                margin-left: 20px;
                display: flex;
                align-items: center;
                position: relative;
                padding: 20px 0;
                .s-top-userset-menu{
                  display: block;
                }
              }
              .go{
                width: 20px;
                margin-left: 18px;
                //cursor: pointer;
              }

              .s-top-userset-menu {
                  display: none;
                  padding: 8px 0;
                  width: 150px;
                  font-size: 14px;
                  top: 87px;
                  right: 26px;
                  position: absolute;
                  right: 10px;
                  float: right;
                  z-index: 999;
                  text-align: left;
                  background: #fff;
                  box-shadow: 0 2px 10px 0 rgba(0,0,0,.15);
                  border-radius: 12px;
              }
              .s-top-right-new {
                margin-left: 24px;
              }
              .s-top-userset-menu a {
                  display: block;
                  margin: 3px 16px 3px 16px;
                  color: #333;
                  text-decoration: none;
                  text-align: center;
                  padding-bottom: 3px;
              }
              .s-top-userset-menu a:hover{
                color: #8096f1;
              }
              .s-top-userset-menu a:nth-child(2){
                border-top: 1px solid #eee;
                padding-bottom: 0;
                padding-top: 3px;
              }

            }
          }
        }
    }
</style>
